import { Modal } from 'corso-admin-ui';
import { OrderTracking } from '~/components/tracking/OrderTracking';

export function ShippingClaimReorderTrackingModal({
  show,
  onClose,
  storeOrderId,
}: {
  show: boolean;
  onClose: () => void;
  storeOrderId: number;
}) {
  return (
    <Modal show={show} onClose={onClose} title="Reorder Tracking">
      <OrderTracking
        storeOrderId={storeOrderId}
        emptyMessage="The reorder has not shipped yet."
      />
    </Modal>
  );
}
